import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PaymentProvider } from '../../providers/payment';
import { IUser } from '../../models/user.model';
import { Query } from '@firebase/database-types';
import { UtilitiesProvider } from '../../providers/utilities';
import { AnalyticsData, _ACTIONS } from '../../providers/analytics';

const componentName = 'CartTicketItemComponent';

@Component({
  selector: 'app-cart-ticket-item',
  templateUrl: 'cart-ticket-item.component.html'
})

export class CartTicketItemComponent {

  @Input() public uidTrack: string;
  @Input() public ticket: any;
  @Input() public clientId: string;
  @Input() public config: any;
  @Input() public user: IUser;
  @Input() public ticketIndex: number;
  @Output() public resize = new EventEmitter();

  public maxStockFlag = false;
  public noStockFlag = false;
  public shoppingCartRef: Query;
  public ticketRef: Query;

  constructor(
    private paymentProvider: PaymentProvider,
    private utilities: UtilitiesProvider,
    private navCtrl: NavController,
    private navParams: NavParams,
    private analytics: AnalyticsData,
  ) { }

  public async delete(ticket) {
    this.utilities.alert.create({
      title: await this.utilities.translateTextOrObject('Alert'),
      message: await this.utilities.translateTextOrObject('Are you sure to remove this ticket from shopping cart?'),
      buttons: [{
        text: await this.utilities.translateTextOrObject('Remove'),
        handler: () => {
          const load = this.utilities.setLoading();
          this.paymentProvider.removeTicketFromShoppingCart(this.user.info.id, ticket.id)
            .then(() => this.presentToast('Item deleted correctly'))
            .then(() => {
              // TrackingAction - Detele Product
              this.analytics.savePageTrackOnFirestore(
                componentName,
                _ACTIONS.deleteTicketCart,
                this.uidTrack,
                { ticketId: ticket.id }
              );
            })
            .then(() => load.dismiss());
        }
      }, {
        text: await this.utilities.translateTextOrObject('Cancel'),
        role: 'cancel'
      }]
    }).present();
  }

  /**
   * Push to carrousel catalog page and view the product detail
   * @author Jhonny Martínez
   */
  public view() {
    const eventId = this.navParams.get('eventId');
    const ticketId = this.ticket.id;
    this.navCtrl.push('DetailTicket', { eventId, ticketId });
  }

  public viewFees() {
    const ticketId = this.ticket.id;
    this.navCtrl.push('MaintenancePay', { ticketId });
  }

  public getUrl(image) {
    return `url('${image}')`;
  }

  /**
   *
   * @param product
   */
  public calculatePriceWithDiscount(ticket: any) {
    if (ticket.sale_discount > 0) {
      return (parseInt(ticket.sale_price) - (parseInt(ticket.sale_price) * (parseInt(ticket.sale_discount) / 100)));
    }

    return ticket.sale_price
  }

  public calculatePriceReference(ticket: any) {
    if (ticket.sale_discount > 0) {
      return ticket.sale_price
    }

    return null;
  }

  private async presentToast(message) {
    return this.utilities.toast.create({
      message: await this.utilities.translateTextOrObject(message),
      position: 'top',
      duration: 2000
    }).present();
  }

  public reload() {
    this.resize.emit();
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/components/cart-ticket-item/cart-ticket-item.component.ts